import ApiService from './api-service'

class App extends ApiService {
    constructor() {
        super()

        this.get = null
        // this.post = null
        this.put = null
        this.delete = null
    }


    async clearAll() {
      return Promise.all([
        super.clear('/app'), 
        super.clear('/app/check')
      ]);
    }

    check({ version, platform } = {}, options) {
      return super.post(`app/check`, { version, platform }, options)
    }
}

const _App = new App()
export default _App
